import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=b6b33e6e&"
import script from "./triangle.vue?vue&type=script&lang=ts&"
export * from "./triangle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports